// extracted by mini-css-extract-plugin
export default {"question":"question_question__18gJe","question--selected":"question_question--selected__-wv5h","question__content":"question_question__content__YzCGW"};